export const LOAD_ALL_TASKS = 'LOAD_ALL_TASKS';
export const LOAD_DETAILS_WITHOUT_PROPERTY = 'LOAD_DETAILS_WITHOUT_PROPERTY';
export const LOAD_DETAILS_BY_BOARD_ID = 'LOAD_DETAILS_BY_BOARD_ID';
export const LOAD_TASKS_WITHOUT_POSITION = 'LOAD_TASKS_WITHOUT_POSITION';
export const LOAD_TASK_CLOCKS = 'LOAD_TASK_CLOCKS';
export const REVERT_TASK_ASSIGNMENT_BY_TASK_ID = 'REVERT_TASK_ASSIGNMENT_BY_TASK_ID';
export const SET_TASK_POSITION_BY_TASK_ID_AND_POSITION = 'SET_TASK_POSITION_BY_TASK_ID_AND_POSITION';
export const SEND_EMAIL_BY_TASK_ID_AND_STAGE_ID = 'SEND_EMAIL_BY_TASK_ID_AND_STAGE_ID';
export const ARCHIVED_BY_TASK_ID = 'ARCHIVED_BY_TASK_ID';
export const LOAD_DETAIL_PROJECT_TASKS = 'LOAD_DETAIL_PROJECT_TASKS';
export const CLEAR_LANES = 'CLEAR_LANES';
export const CLEAR_TASKS = 'CLEAR_TASKS';

export function loadAllTasks(data) {
  return {
    type: LOAD_ALL_TASKS,
    payload: data,
  }
}

export function clearLanes(data) {
    return {
      type: CLEAR_LANES,
      payload: data,
    }
}

export function clearTasks() {
  return {
    type: CLEAR_TASKS,
  }
}

export function loadDetailsWithoutProperty(data) {
    return {
      type: LOAD_DETAILS_WITHOUT_PROPERTY,
      payload: data,
    }
}

export function loadDetailsByBoardId(data) {
    return {
      type: LOAD_DETAILS_BY_BOARD_ID,
      payload: data,
    }
}

export function loadTasksWithoutPosition(data) {
    return {
      type: LOAD_TASKS_WITHOUT_POSITION,
      payload: data,
    }
}

export function loadTaskClocks(data) {
    return {
      type: LOAD_TASK_CLOCKS,
      payload: data,
    }
}

export function revertTaskAssignmentByTaskId(data) {
    return {
      type: REVERT_TASK_ASSIGNMENT_BY_TASK_ID,
      payload: data,
    }
}

export function setTaskPositionByTaskIdAndPosition(data) {
    return {
      type: SET_TASK_POSITION_BY_TASK_ID_AND_POSITION,
      payload: data,
    }
}

export function sendEmailByTaskIdAndStageId(data) {
    return {
      type: SEND_EMAIL_BY_TASK_ID_AND_STAGE_ID,
      payload: data,
    }
}

export function archivedByTaskId(data) {
    return {
      type: ARCHIVED_BY_TASK_ID,
      payload: data,
    }
}

export function loadDetailProjectTask(data) {
  return {
    type: LOAD_DETAIL_PROJECT_TASKS,
    payload: data,
  }
}



// WEBPACK FOOTER //
// ./src/actions/dashboard/index.js